"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "tenno": {
    "bc6570fe": [{
      "hkey": "64f9dfa0",
      "slug": "cologna-gavazzo-nuova",
      "name": "Cologna-Gavazzo Nuova",
      "primary": true,
      "skipSearch": false
    }],
    "cologna-gavazzo-volta-di-noo": [{
      "hkey": "64f9dfa0",
      "slug": "cologna-gavazzo-nuova",
      "name": "Cologna-Gavazzo Nuova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "bffd4b7d": [{
      "hkey": "f0d7c171",
      "slug": "tenno",
      "name": "Tenno",
      "primary": true,
      "skipSearch": false
    }],
    "mattoni": [{
      "hkey": "f0d7c171",
      "slug": "tenno",
      "name": "Tenno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "27c55f06": [{
      "hkey": "f0d7c171",
      "slug": "tenno",
      "name": "Tenno",
      "primary": true,
      "skipSearch": false
    }],
    "teggiole": [{
      "hkey": "f0d7c171",
      "slug": "tenno",
      "name": "Tenno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "de07c76d": [{
      "hkey": "1ce9af97",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "tenno": [{
      "hkey": "1ce9af97",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "375a9164": [{
      "hkey": "6aa8ddea",
      "slug": "ville-del-monte",
      "name": "Ville del Monte",
      "primary": true,
      "skipSearch": false
    }],
    "ville-del-monte-lago-di-tenno": [{
      "hkey": "6aa8ddea",
      "slug": "ville-del-monte",
      "name": "Ville del Monte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;